// extracted by mini-css-extract-plugin
export default {"mediumWidth":"AztQpIf0gmECQOSB7i88"};